module.exports = __webpack_public_path__ + "static/media/lumbering9.99c32fb5.jpg";